<template>
  <div 
    id="fundo"
    class="tw-hidden lg:tw-flex tw-items-center tw-justify-center tw-w-[480px] tw-pt-8 tw-h-full tw-cursor-pointer tw-overflow-y-hidden"
    @click="abrirLink"
  >
    <!--  URL padrão alterada pelo time de marketing através do Wordpress -->
    <img 
      src="https://econodata.com.br/banner-login/" 
      alt=""
      width="480"
    >
  </div>
</template>

<script>
export default {
  methods: {
    abrirLink(){
      // URL padrão alterada pelo time de marketing através do Wordpress
      window.open('https://econodata.com.br/url-banner-login', '_blank')
    }
  }
}
</script>

<style scoped>
#fundo {
  background-image: url("../../assets/images/Roda-fundo.webp");
  background-repeat: no-repeat;
  background-position: 0% 60%;
}
</style>
